import { useEffect } from 'react';
import { GameStatus } from '@secretnenshi/shared';
import { useTheme } from './theme/useTheme';
import { ConnectionBar, FirstLaunchDisclaimer } from './components/chrome';
import { Page } from './components/ui';
import { CreateGame } from './screens/CreateGame';
import { Game } from './screens/Game';
import { Info } from './screens/Info';
import { JoinGame } from './screens/JoinGame';
import { Landing } from './screens/Landing';
import { Lobby } from './screens/Lobby';
import { ReclaimWaiting } from './screens/ReclaimWaiting';
import { useStore } from './state/store';

export function App() {
  const th = useTheme();
  useEffect(() => {
    document.title = th.t.title;
  }, [th]);
  return (
    <>
      <ConnectionBar />
      <Screen />
      <FirstLaunchDisclaimer />
    </>
  );
}

function Screen() {
  const screen = useStore((s) => s.screen);
  const view = useStore((s) => s.view);

  switch (screen.name) {
    case 'landing':
      return <Landing />;
    case 'create':
      return <CreateGame />;
    case 'join':
      return <JoinGame initialCode={screen.code} initialName={screen.playerName} />;
    case 'reclaim':
      return <ReclaimWaiting code={screen.code} playerName={screen.playerName} />;
    case 'info':
      return <Info page={screen.page} />;
    case 'game':
      if (!view) return <Page><p className="hint">Loading…</p></Page>;
      return view.status === GameStatus.LOBBY ? <Lobby view={view} /> : <Game view={view} />;
  }
}
